import { render, staticRenderFns } from "./order_pinfo.vue?vue&type=template&id=6eb2aacf&scoped=true&"
import script from "./order_pinfo.vue?vue&type=script&lang=js&"
export * from "./order_pinfo.vue?vue&type=script&lang=js&"
import style0 from "./order_pinfo.vue?vue&type=style&index=0&id=6eb2aacf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb2aacf",
  null
  
)

export default component.exports